'use strict';



export default {

	setVars(vars) {
		for (var k in vars) {
			if(vars["SANDBOX_MODE"]==true || vars["SANDBOX_MODE"]==='true'){
				if(k.search("_SANDBOX")!==-1){
					this[k.replace("_SANDBOX","")] = vars[k];
				}
				this["SANDBOX_MODE"] = true;
			}else{
				if(k.search("_PROD")!==-1){
					this[k.replace("_PROD","")] = vars[k];
				}
				this["SANDBOX_MODE"] = false;
			}
		}
	}

}


// WEBPACK FOOTER //
// ./src/frontend-standard-library/modules-react/Base/Config/Settings.js